import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { ApplicationState } from 'AppReducer'
import { getUserByPerson } from '../redux/actions'

import UserCard from '../manager/components/UserCard'
import UserList from 'panel/user/manager/components/UserList'
import UserExtraMenu from '../manager/components/UserExtraMenu'

import DocumentForm from './DocumentForm'
import DocumentList from './DocumentList'

const DocumentManager: React.FC = () => {
  const { personId } = useParams<{ personId: string }>()

  const dispatch = useDispatch()
  const { user } = useSelector((state: ApplicationState) => state.userReducer)

  useEffect(() => {
    if (personId && !user) {
      getUserByPerson(personId)(dispatch)
    }
  }, [personId, user, dispatch])

  return (
    <div className="row">
      <div className="row padding-left-8 margin-bottom-16">
        <div className="row" style={{ width: 400 }}>
          <h1 className="col-12 bold-center">Gestão de Documentos</h1>
          <p className="col-12 no-margin">Crie, edite, busque e remova documentos</p>
        </div>
        <div className="row grow padding-left-16">
          <UserExtraMenu />
        </div>
      </div>

      <UserCard />

      <div className="row panel margin-top-16">
        <DocumentForm />
        <DocumentList />
      </div>

      <UserList />
    </div>
  )
}

export default DocumentManager
